import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environments';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() { }
  

  setDataToLocalStorage(name: string, value: any) {
    if (!name || !value) {
      return;
    }
    try {
      if (value && typeof value === 'string') {
        localStorage.setItem(name, this.encrypt(value));
        return;
      }
      localStorage.setItem(name, this.encrypt(JSON.stringify(value)));
    } catch (err) {
      console.error('Failed:', err);
      console.info('May be issue with local storage');
    }
  }

  getDataFromLocalStorage(item: string): any {
    if (!item || typeof item !== 'string') {
      return;
    }
    const localData = localStorage.getItem(item);
    if (!localData) {
      return;
    }
    try {
      const decrypted = this.decrypt(localData);
      if (decrypted?.startsWith('{') || decrypted?.startsWith('[')) {
        return JSON.parse(decrypted);
      }
      return decrypted;
    } catch (e) {
      console.error('Decryption or Parsing Failed:', e);
      return this.decrypt(localData);
    }
  }

  removeDataFromLocalStorage(item: any) {
    if (!item || typeof item !== 'string') {
      return;
    }
    localStorage.removeItem(String(item));
  }

  clearLocalStorage() {
    localStorage.clear();
  }

  encrypt(value: any) {
    return CryptoJS.AES.encrypt(value, environment.PRIVATE_KEY).toString();
  }

  decrypt(value: any) {
    try {
      if (!value || typeof value !== 'string') {
        return '';
      }
      if (!value.startsWith('U2FsdGVkX1')) {
        return value;
      }
      const bytes = CryptoJS.AES.decrypt(value, environment.PRIVATE_KEY);
      const decrypted = bytes.toString(CryptoJS.enc.Utf8);
      if (!decrypted) {
        return '';
      }
      return decrypted;
    } catch (ex) {
      console.error('Decrypt Failed:', ex);
      return '';
    }
  }


}
